// The one address search engines treat as authoritative — every deployed
// hostname (web.app, run.app, staging channels) canonicalizes here.
export const CANONICAL_ORIGIN = "https://turtlewave.art";

/** Entity first, brand after: "Whale Song — TurtleWave". */
export const pageTitle = (entity?: string) =>
  entity ? `${entity} — TurtleWave` : "TurtleWave";

/** Canonical link descriptor for a path. Exclude presentation params. */
export const canonical = (path: string) => ({
  tagName: "link" as const,
  rel: "canonical",
  href: `${CANONICAL_ORIGIN}${path}`,
});
